<template>
  <div>
    <osv-basket-icon on-change="callback" />
  </div>
</template>

<script>
export default {
  methods: {
    callback() {
      console.log("hello");
    },
    showShopToast() {
      //this.$store.commit("TOGGLE_SHOP_TOAST");
    },
  },
};
</script>

<style lang="scss" scoped></style>
